// extracted by mini-css-extract-plugin
export var card = "_m6-5";
export var cardSelected = "_m6-4";
export var image = "_m6-3";
export var modal = "_m6-0";
export var modalContent = "_m6-1";
export var table = "_m6-2";